////
/// ============================================================================
/// COMPONENT / Video
/// ============================================================================
///
/// @group components
////

import Plyr from 'plyr';
import cursor from './cursor';

export default () => {
    document.querySelectorAll('.is-type-video .wp-block-embed__wrapper').forEach((element) => {
        let player = new Plyr(element, {
            controls: [
                'play-large'
            ],
            iconUrl: templateUrl + '/assets/sprite.svg',
            iconPrefix: 'icon-'
        });

        // Cursor
        player.on('ready', (event) => {
            element.addEventListener('mouseenter', () => {
                cursor().setText('Play');
            });

            element.addEventListener('mouseleave', () => {
                cursor().removeText();
            });
        });

        player.on('play', (event) => {
            cursor().setText('Pause');
        });

        player.on('pause', (event) => {
            cursor().setText('Play');
        });
    });
};
